import { DependentsAction } from "../../@types/contexts/dependentContext/dependentAction.types";
import { Store } from "../../@types/contexts/dependentContext/store.types";
import actions from "./actions";

const reducer = (state: Store, action: DependentsAction): Store => {
	switch (action.type) {
		case actions.SET_DEPENDENTS: {
			return {
				...state,
				dependents: action.payload
			};
		}
		default:
			throw new Error("Unexpected action: Auth Context");
	}
};

export default reducer;
